export default "__VITE_ASSET__DzZf1Jk4__"